import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrRecruitmentApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    recruitmentDashboard(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrRecruitmentDashboard>> {
        return this.http.get<APIResponseWrapper<HrModels.HrRecruitmentDashboard>>(`${this.baseUrl}/recruitment/dashboard`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    recruitmentRequisitions(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrRequisition[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrRequisition[]>>(`${this.baseUrl}/recruitment/requisitions`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveRecruitmentRequisition(request: HrModels.HrRequisition): Observable<APIResponseWrapper<HrModels.HrRequisition>> {
        return request.requisitionId
          ? this.http.put<APIResponseWrapper<HrModels.HrRequisition>>(`${this.baseUrl}/recruitment/requisitions/${request.requisitionId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrRequisition>>(`${this.baseUrl}/recruitment/requisitions`, request);
      }
    
    decideRecruitmentRequisition(requisitionId: number, request: HrModels.HrRecruitmentDecisionRequest): Observable<APIResponseWrapper<HrModels.HrRequisition>> {
        return this.http.post<APIResponseWrapper<HrModels.HrRequisition>>(`${this.baseUrl}/recruitment/requisitions/${requisitionId}/decision`, request);
      }
    
    recruitmentCandidates(owningCompanyId?: number, search?: string): Observable<APIResponseWrapper<HrModels.HrCandidate[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCandidate[]>>(`${this.baseUrl}/recruitment/candidates`, {
          params: this.params({ owningCompanyId, search })
        });
      }
    
    saveRecruitmentCandidate(request: HrModels.HrCandidate): Observable<APIResponseWrapper<HrModels.HrCandidate>> {
        return request.candidateId
          ? this.http.put<APIResponseWrapper<HrModels.HrCandidate>>(`${this.baseUrl}/recruitment/candidates/${request.candidateId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrCandidate>>(`${this.baseUrl}/recruitment/candidates`, request);
      }
    
    importRecruitmentCandidates(request: HrModels.HrCandidateImportRequest): Observable<APIResponseWrapper<HrModels.HrCandidateImportResult>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCandidateImportResult>>(`${this.baseUrl}/recruitment/candidates/import`, request);
      }
    
    saveCandidateDocument(candidateId: number, request: HrModels.HrCandidateDocument): Observable<APIResponseWrapper<HrModels.HrCandidateDocument>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCandidateDocument>>(`${this.baseUrl}/recruitment/candidates/${candidateId}/documents`, request);
      }
    
    recruitmentApplications(owningCompanyId?: number, stage?: string): Observable<APIResponseWrapper<HrModels.HrApplication[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrApplication[]>>(`${this.baseUrl}/recruitment/applications`, {
          params: this.params({ owningCompanyId, stage })
        });
      }
    
    createRecruitmentApplication(request: HrModels.HrApplication): Observable<APIResponseWrapper<HrModels.HrApplication>> {
        return this.http.post<APIResponseWrapper<HrModels.HrApplication>>(`${this.baseUrl}/recruitment/applications`, request);
      }
    
    transitionRecruitmentApplication(applicationId: number, request: HrModels.HrApplicationStageTransitionRequest): Observable<APIResponseWrapper<HrModels.HrApplication>> {
        return this.http.post<APIResponseWrapper<HrModels.HrApplication>>(`${this.baseUrl}/recruitment/applications/${applicationId}/transition`, request);
      }
    
    saveRecruitmentInterview(request: HrModels.HrInterview): Observable<APIResponseWrapper<HrModels.HrInterview>> {
        return request.interviewId
          ? this.http.put<APIResponseWrapper<HrModels.HrInterview>>(`${this.baseUrl}/recruitment/interviews/${request.interviewId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrInterview>>(`${this.baseUrl}/recruitment/interviews`, request);
      }
    
    recruitmentOffers(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrOffer[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrOffer[]>>(`${this.baseUrl}/recruitment/offers`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveRecruitmentOffer(request: HrModels.HrOffer): Observable<APIResponseWrapper<HrModels.HrOffer>> {
        return request.offerId
          ? this.http.put<APIResponseWrapper<HrModels.HrOffer>>(`${this.baseUrl}/recruitment/offers/${request.offerId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrOffer>>(`${this.baseUrl}/recruitment/offers`, request);
      }
    
    decideRecruitmentOffer(offerId: number, request: HrModels.HrOfferDecisionRequest): Observable<APIResponseWrapper<HrModels.HrOffer>> {
        return this.http.post<APIResponseWrapper<HrModels.HrOffer>>(`${this.baseUrl}/recruitment/offers/${offerId}/decision`, request);
      }
    
    convertRecruitmentOffer(offerId: number, request: HrModels.HrOfferConversionRequest): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/recruitment/offers/${offerId}/convert`, request);
      }
  };
}

